import {useClientsContext} from '../hooks/useClientsContext'
import {useEffect, useState} from 'react'
import {useAuthContext} from "../hooks/useAuthContext"
import '../styling/ClientList.css'
import { useNavigate } from 'react-router-dom';
import API_BASE_URL from '../config.js';


const ClientList = ({searchTerm}) => {

  const navigate = useNavigate();

  const {clients, dispatch} = useClientsContext();

  const {user} = useAuthContext();

  const handleAccessClick = (clientId) => {
    // Navigate to the ClientDetails page with the specific client ID
    navigate(`/client/${clientId}`);
  };

  useEffect(() => {
    const fetchClients = async () => {

        const response = await fetch(`${API_BASE_URL}/api/client`, {
            headers: {"Authorization": `Bearer ${user.token}`}
        })

        const json = await response.json()

        if(response.ok){
            dispatch({type: "SET_CLIENTS", payload:json})
        }     
    }
    if (user){
        fetchClients()
    }  

// add clients to dependency below to update deleted client. //
  }, [dispatch,user])

  const filterClients = () => {
    if (searchTerm.trim() === '') {
      // If search term is empty, return all clients
      return clients;
    }

    return clients.filter(
      (client) =>
        client.clientFirst.toLowerCase().includes(searchTerm.toLowerCase()) ||
        client.clientLast.toLowerCase().includes(searchTerm.toLowerCase()) ||
        client.clientCountry.toLowerCase().includes(searchTerm.toLowerCase()) ||
        client.clientStreet1.toLowerCase().includes(searchTerm.toLowerCase()) ||
        client.clientStreet2.toLowerCase().includes(searchTerm.toLowerCase()) ||
        client.clientCity.toLowerCase().includes(searchTerm.toLowerCase()) ||
        client.clientState.toLowerCase().includes(searchTerm.toLowerCase()) ||
        client.clientPhone.toLowerCase().includes(searchTerm.toLowerCase())
    );
  };

    return ( 

        <div className="clientlist">
            <div className="overflow-x-auto">
  <table className="table">
    {/* head */}
    <thead>
      <tr>
        <th>
          <label>
            
          </label>
        </th>
        <th>Name</th>
        <th>Property</th>
        <th>Contact</th>
        <th></th>
      </tr>
    </thead>
    <tbody>
      {/* row 1 */}

      {clients && filterClients().map((client) => {
  return (
    <tr key={client._id}>
      <th>
        <label>
          
        </label>
      </th>
      <td>
        <div className="flex items-center gap-3">
          <div className="avatar">
            <div className="mask mask-squircle w-12 h-12">
            </div>
          </div>
          <div>
            <div className="font-bold">{client.clientFirst} {client.clientLast}</div>
            <div className="text-sm opacity-50">{client.clientCountry}</div>
          </div>
        </div>
      </td>
      <td>
        {client.clientStreet1} {client.clientStreet2} {client.clientCity} {client.clientState}
      </td>
      <td>{client.clientPhone}</td>
      <th>
      <button className="btn" id="accessbutton" onClick={() => handleAccessClick(client._id)}>
        Access
      </button>
      </th>
    </tr>
  );
})}


     
      </tbody>
    
  </table>
</div>
        </div>

    );
}
 
export default ClientList;